import { List, ListItem, Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  HelpDialogList,
  SectionStack
} from "./HelpDialogLayout";

export interface NapDialogProps extends HelpDialogLayoutProps {
}
export default function NapDialog(props: NapDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            仮眠の効果と夜の睡眠への影響
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "夜間毎日十分な睡眠をとることが重要ですが、仕事や生活の都合で睡眠時間を十分確保できず、日中に眠気がある場合には、昼間の短い仮眠をとることで眠気の軽減効果があります。",
                "一方で、夕方以降の仮眠はその夜の睡眠に寝付きが悪くなるなどの影響を及ぼします。",
                "※なお、日中は睡眠が浅くなりやすく、時間も短いため、夜の睡眠のような深く回復力のあるものではありません。あくまで補完的なものと考え、上手に活用しましょう。",
              ]}
            />
          </ContentStack>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            効果的な仮眠のとり方
          </Typography>
          <ContentStack>
            <HelpDialogList
            >
              <ListItem>
                <BodyTypographies
                  contents={[
                    "時間：短く30分以内にとどめましょう。",
                    "30分を超えた長い昼寝は目覚めの悪さを生じさせて午後の活動に影響し、またその日の夜の睡眠に影響してしまいます。仮眠を取る前に、（摂取後20～30分後に覚醒作用の出る）カフェインを摂ってから寝ることで寝過ぎを避けられます。※夜勤で16時間勤務、等の交替かつ長時間勤務の場合はこの限りではありません。",
                  ]}
                />
              </ListItem>
              <ListItem>
                <BodyTypographies
                  contents={[
                    "タイミング：寝る時刻の8時間前より前にしましょう。（例：23時に眠りにつきたい場合は、15時より前に仮眠をとる。）可能であれば、昼食後の自然と眠くなる時間帯がおすすめです。",
                  ]}
                />
              </ListItem>
              <ListItem>
                <BodyTypographies
                  contents={[
                    "環境：光をできる限りシャットアウトできる場所を選んだり、アイマスクをすることが効果的です。パソコンや電子音もできる限り遮断しましょう。横にならず、机に突っ伏した状態や、椅子の背もたれに寄りかかって寝る姿勢が深く眠り過ぎず、良いとされています。",
                  ]}
                />
              </ListItem>
            </HelpDialogList>
          </ContentStack>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            気を付けること
          </Typography>
          <ContentStack>
            <List
              sx={{
                listStyleType: "disc",
                pl: 2,
                py: 0,
                "& .MuiListItem-root": {
                  display: "list-item",
                  lineHeight: "21px",
                  pl: 2,
                  py: 0,
                  "&::marker": {
                    color: "text.secondary",
                    content: "'・'",
                    fontSize: "12px",
                    fontWeight: 400,
                  },
                },
              }}
            >
              <ListItem>
                <BodyTypographies
                  contents={[
                    "夜にソファなどで寝落ちしてしまうことは避けましょう。睡眠が分断されてしまい、夜の睡眠の質に悪影響があります。",
                    "夜に寝落ち（仮眠）することが習慣になっている場合、慢性的な睡眠不足が考えられますので、質と同時に睡眠の長さも見直してみましょう。子供の寝かしつけで寝落ちしてしまいがちな方は、夜の作業を朝に振り分けて、夜は子供と同じ時間に寝てしまえないかを今一度検討してみましょう。",
                  ]}
                />
              </ListItem>
            </List>
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
